import { Button, ButtonGroup, Card, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { capitalized } from "../helpers/strings";
import { useUpdateOrderMutation } from "../features/model/orderSlice";
import { useState } from "react";
import { deepEqual } from "../helpers/objects";
import { useListDiscountsQuery } from "../features/model/discountSlice";
import Loading from "./Loading";
import { useRunActionMutation } from "../features/actions/actionsSlice";
import { allStatuses, mapStatus, reverseMapStatus } from "../helpers/statuses";

const OrderEditCard = ({order}) => {
    const [state, setState] = useState(order);
    const [totalEx, setTotalEx] = useState(`${order.total_excluding_tax}`)
    const [totalIn, setTotalIn] = useState(`${order.total_including_tax}`)
    const [tax, setTax] = useState(`${order.tax}`)
    const [codeNote, setCodeNote] = useState("");
    const [updateOrder] = useUpdateOrderMutation();
    const {data: codes, error, isLoading } = useListDiscountsQuery();
    const [discountCode, setDiscountCode] = useState(null);
    const [runAction, {data: actionData}] = useRunActionMutation();

    const order_statuses = allStatuses();

    if (isLoading) {
        return <Loading />;
    }
    if (error) {

    } else {
        if(codes) {
            if(order.discount !== null && discountCode === null) {
                codes.objects.forEach(discount => {
                    if(discount.id === order.discount) {
                        if(discountCode !== discount.code) {
                            setDiscountCode(discount.code);
                        }
                    }
                });
            }
        }
    }

    const handleSave = () => {
        updateOrder({order_id: order.id, data: {...state}})
    };

    const handleRevert = () => {
        setState(order);
    };

    if(parseFloat(totalEx)) {
        let totalExf = parseFloat(totalEx);
        if (totalExf !== state.total_excluding_tax) {
            setState({...state, total_excluding_tax: totalExf});
        }
    }

    if(parseFloat(totalIn)) {
        let totalInf = parseFloat(totalIn);
        if (totalInf !== state.total_including_tax) {
            setState({...state, total_including_tax: totalInf});
        }
    }

    if(parseFloat(tax)) {
        let taxf = parseFloat(tax);
        if (taxf !== state.tax) {
            setState({...state, tax: taxf});
        }
    }
    const checkDiscountCode = (code) => {
        codes.objects.forEach(discount => {
            if(discount.code.toUpperCase() === code.toUpperCase()) {
                setCodeNote("Code found!");
                setState({...state, discount: discount.id})
            } else {
                if(code !== "") {
                    setCodeNote("No match.");
                } else {
                    setCodeNote("");
                    setState({...state, discount: null})
                }
            }
        });
    };

    const handleDiscountCode = (code) => {
        if(code === "") {
            setState({...state, discount: null});
        } else {
            codes.objects.forEach(discount => {
                if(discount.code.toUpperCase() === code.toUpperCase()) {
                    setState({...state, discount: discount.id});
                }
            });
        }
    }

    const changeOrderStatus = (event) => {
        let new_value = reverseMapStatus(event.target.value);
        runAction({action: "order_change_status", data: {
            id: state.id,
            status: new_value
        }}).then(() => {
            window.location.reload();
        })
    }

    console.log(order_statuses);

    return <Card>
        <Stack direction="column" sx={{margin: 2}} spacing={2}>
            <Typography variant="h2">Order {state.order_id}</Typography>
            <Typography variant="h3" sx={{marginBottom: 1}}>Current status: {state.status ? capitalized(mapStatus(state.status)) : ""}</Typography>
            <FormControl fullWidth>
                <InputLabel id="status-select-label">Change status to</InputLabel>
                <Select label="Change status to" key="status" defaultValue={mapStatus(state.status)} labelId="status-select-label"
                    onChange={changeOrderStatus}
                >
                    {order_statuses.map((st)=><MenuItem key={st} value={st}>{capitalized(st)}</MenuItem>)}
                </Select>
            </FormControl>
            <TextField label="Recipient" value={state.recipient_name ? state.recipient_name : ""} onChange={(e) => {setState({...state, recipient_name: e.target.value})}} />
            <TextField label="Company" value={state.company ? state.company : ""} onChange={(e) => {setState({...state, company: e.target.value})}} />
            <TextField label="Address" value={state.address ? state.address : ""} onChange={(e) => {setState({...state, address: e.target.value})}} />
            <Stack direction="row" spacing={2}>
                <TextField label="City" value={state.city ? state.city : ""} onChange={(e) => {setState({...state, city: e.target.value})}} />
                <TextField label="Postal Code" value={state.postal_code ? state.postal_code : ""} onChange={(e) => {setState({...state, postal_code: e.target.value})}} />
            </Stack>
            <Stack direction="row" spacing={2}>
                <TextField label="State" value={state.state ? state.state : ""} onChange={(e) => {setState({...state, state: e.target.value})}} />
                <TextField label="Country" value={state.country ? state.country : ""} onChange={(e) => {setState({...state, country: e.target.value})}} />
            </Stack>
            <TextField label="Email" value={state.email ? state.email : ""} onChange={(e) => {setState({...state, email: e.target.value})}} />
            <TextField label="Notes" value={state.comments ? state.comments : ""} rows={4} multiline={true} onChange={(e) => {setState({...state, comments: e.target.value})}} />

            <TextField label="Total excl. tax ($)" value={totalEx} onChange={(e) => {setTotalEx(e.target.value)}} />
            <Stack direction="row" spacing={2}>
                <TextField label="Total incl. tax ($)" value={`${state.total_including_tax}`} onChange={(e) => {setTotalIn(e.target.value)}} />
                <TextField label="Tax ($)" value={`${state.tax}`} onChange={(e) => {setTax(e.target.value)}} />
            </Stack>
            <Stack direction="row" spacing={2}>
                <TextField label="Discount code" value={discountCode ? discountCode : ""} onChange={(e) => {setDiscountCode(e.target.value.toUpperCase()); checkDiscountCode(e.target.value.toUpperCase());}} onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleDiscountCode(e.target.value);
                  }
                }} />
                <Typography variant="p">{codeNote}</Typography>
            </Stack>

            <ButtonGroup>
                <Button variant="contained" disabled={deepEqual(state, order)} onClick={handleSave}>Save</Button>
                <Button variant="outlined" onClick={handleRevert}>Revert</Button>
            </ButtonGroup>
        </Stack>
    </Card>;
};


export { OrderEditCard };